import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { pathOr, pathEq } from 'ramda';

import Eye from '../icons/eye-svg';
import PopUp from '../commons/component/popup';
import Recaptcha from '../commons/component/captcha/recaptcha';
import Input from '../commons/component/input';
import InputNumber from '../commons/component/input-number';
import Button from '../commons/component/button';
import EntrarTelemarketerWithCustomer from './entrar-telemarketer-with-customer-component';
import Entrar2StepLogin from './entrar-login-2etapas-component';

import { isQuiosque, isTelevendas } from '../commons/utils/sales-channel';
import { sendSuccessfulyMessage, sendFailMessage } from '../commons/utils/post-message';
import { getCookie, safelySetCookie } from '../commons/cookie';

import login, {
  getErrorMessageByErrorCode,
  isCustomerLocked,
  getStepAfterLogin
} from './entrar-action';

import { dispatchErrorEvent } from '../api/account/authenticate';

import { setFocusById, isEmbedded, getAllQueryParams, pushOrRedirect } from '../commons/query';

import ForgotPasswordForm from './forgot-password-form';
import FacebookButton from './facebook-button';
import GoogleButton from './google-button';

import config from '../generated/config';
import UserIcon from '../icons/user-icon';
import { setUserEmail } from '../api/customer/login';
import { PrivacyPolicy } from './styles';
import { dispatchLoadEvent } from '../cadastro/metrics';

const {
  facebookAppId,
  googleAppId,
  enableCaptchaOnLogin,
  enableGoogleLogin,
  enableFacebookLogin,
  brand,
  showCNPJOnLogin,
  show2stepLogin,
  url
} = config;

const getEmailProps = () => {
  if (pathEq(['brand'], 'shop', config)) {
    return {
      type: 'text'
    };
  } else {
    return {
      type: 'email'
    };
  }
};

const emailFieldLabel = () => (brand === 'shop' ? 'E-mail ou CPF:' : 'E-mail:');

const emailFieldPlaceholder = () => (brand === 'shop' ? '' : 'Ex. joaodasilva@gmail.com');

const hasLoginGuestInParams = params =>
  Boolean(params.guest) || pathOr('', ['p'], params).includes('lg');

const facebookLoginEnabled =
  enableFacebookLogin && facebookAppId && !(isQuiosque() || isTelevendas());
const googleLoginEnabled = googleAppId && enableGoogleLogin && !(isQuiosque() || isTelevendas());

const passwordTitle = () => {
  return `Senha ${config.atBrandName}:`;
};

const hasTelemarketer = () => !!(getCookie('telemarketerId') && getCookie('telemarketerToken'));

class Entrar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      popup: {
        isShowing: false,
        title: '',
        content: null
      },
      login: {
        showPassword: false,
        isSubmitting: false,
        defaultErrorMessage: 'E-mail ou senha incorretos',
        errorMessage: '',
        password: '',
        email: '',
        cnpj: ''
      },
      guestLogin: {
        isShowing: false,
        isSubmitting: false,
        defaultErrorMessage: 'Número do pedido ou CPF incorretos',
        errorMessage: '',
        orderId: '',
        cpf: ''
      }
    };
  }

  redirect(url) {
    return e => {
      e.preventDefault();
      pushOrRedirect(this.props.history.push, {
        url: url,
        push: true
      });
    };
  }

  componentWillMount() {
    this.checkFacebookSDK();
  }

  componentDidMount() {
    dispatchLoadEvent('login');
  }

  render() {
    const { login, guestLogin, popup } = this.state;

    if (hasTelemarketer()) {
      return <EntrarTelemarketerWithCustomer {...this.props} />;
    }

    if (show2stepLogin) {
      return <Entrar2StepLogin {...this.props} />;
    }

    if (this.state.isLoading) {
      return null;
    }

    return (
      <div className="entrar__wrapper">
        <h1 className="entrar-title">
          <UserIcon />
          <span>Login do Cliente</span>
        </h1>
        <form onSubmit={this.submitLogin}>
          {login.errorMessage && (
            <span className="entrar-formError --zeroLeft">{login.errorMessage}</span>
          )}

          {showCNPJOnLogin && (
            <label className="entrar-inputBlock --column" id="cnpj">
              <label className="inputGroup-label --acronym" htmlFor="cnpj-input">
                CNPJ:
              </label>
              <InputNumber
                name="cnpj"
                id="cnpj-input"
                data-page="login"
                data-form="login"
                onChange={this.handleChange('login')}
                value={login.cnpj}
                className={`inputGroup-input`}
                maxLength="11"
                type="text"
                mask="__.___.___/____-__"
                placeholder="Ex: 12.345.678/1234-56"
                required
              />
            </label>
          )}

          <label className="entrar-inputBlock --column" id="emai">
            <label className="entrar-inputLabel">{emailFieldLabel()}</label>
            <Input
              id="email-input"
              placeholder={emailFieldPlaceholder()}
              className="entrar-input form-control"
              data-page="login"
              data-form="login"
              name="email"
              {...getEmailProps()}
              required
              value={login.email}
              onChange={this.handleChange('login')}
              disabled={login.isSubmitting}
              onBlur={
                config.shouldSetUserEmailCookie
                  ? e => safelySetCookie(setUserEmail, e.target.value)
                  : null
              }
            />
          </label>
          <label className="entrar-inputBlock --column --passwordInput" id="password">
            <label className="entrar-inputLabel">{passwordTitle()}</label>
            <div className="entrar-input__wrapper">
              <Input
                id="password-input"
                name="password"
                data-page="login"
                data-form="login"
                className="entrar-input --hasAddon form-control"
                type={login.showPassword ? 'text' : 'password'}
                autoComplete={false}
                required
                value={login.password}
                onChange={this.handleChange('login')}
                disabled={login.isSubmitting}
              />
              <span onClick={this.toggleShowPassword} className="entrar-inputAddon">
                <Eye on={!login.showPassword} />
              </span>
              {this.showForgetPasswordLink()}
            </div>
          </label>

          <Button
            id="login-button"
            primary
            disabled={login.isFormSubmitting}
            loading={login.isFormSubmitting}
            className="entrar-button"
          >
            Continuar
          </Button>
        </form>
        {facebookLoginEnabled && (
          <p className="divisor is-3">
            <span>ou</span>
          </p>
        )}
        {facebookLoginEnabled && <FacebookButton />}
        {googleLoginEnabled && <p className="divisor is-3" />}
        {googleLoginEnabled && <GoogleButton />}
        <PopUp isOpened={popup.isShowing} onClose={this.closePopUp} title={popup.title}>
          {() => popup.content}
        </PopUp>
        {enableCaptchaOnLogin && <Recaptcha ref={ref => (this.captcha = ref)} />}
        <div className="divisor is-4" />
        {this.showRegisterLink()}
        {this.showGuestRegisterLink()}
        {this.isGuestLogin() && guestLogin.isShowing && (
          <form onSubmit={this.submitGuest}>
            {guestLogin.errorMessage && (
              <span className="entrar-formError --zeroLeft">{guestLogin.errorMessage}</span>
            )}
            <label className="entrar-inputBlock --column" id="orderId">
              <label className="entrar-inputLabel">Número do pedido</label>
              <InputNumber
                id="orderId-input"
                className="entrar-input form-control"
                data-page="login"
                data-form="guest"
                name="orderId"
                type="text"
                maxLength="12"
                mask="__-_________"
                required
                value={guestLogin.orderId}
                placeholder={`Ex: 0${config.brandNumber}-XXXXXXXXX`}
                onChange={this.handleChange('guestLogin')}
                disabled={guestLogin.isSubmitting}
              />
            </label>
            <label className="entrar-inputBlock --column" id="cpf">
              <label className="entrar-inputLabel">CPF</label>
              <InputNumber
                name="cpf"
                id="cpf-input"
                data-page="login"
                data-form="guest"
                onChange={this.handleChange('guestLogin')}
                value={guestLogin.cpf}
                disabled={guestLogin.isSubmitting}
                required
                maxLength="11"
                className="entrar-input form-control"
                mask="___.___.___-__"
                placeholder="Ex: 123.456.789-12"
              />
            </label>

            <Button
              id="guest-button"
              primary
              disabled={guestLogin.isSubmitting}
              loading={guestLogin.isSubmitting}
              className="entrar-button"
            >
              Continuar
            </Button>
          </form>
        )}
        {config.brand !== 'aemp' && config.brand !== 'prtl' && (
          <PrivacyPolicy>
            Ao continuar com o acesso, você concorda com a nossa{' '}
            <a target="_blank" rel="noopener noreferrer" href={url.privacyPolicy}>
              Política de Privacidade
            </a>
          </PrivacyPolicy>
        )}
      </div>
    );
  }

  checkFacebookSDK = () => {
    window.FB ? window.location.reload() : this.setState({ isLoading: false });
  };

  showForgetPasswordLink = () => {
    return (
      <span onClick={this.showRetrievePasswordPopUp} className="entrar-inputUpperLink">
        Esqueceu?
      </span>
    );
  };
  showRegisterLink = () => {
    return this.isGuestLogin() ? (
      <p className="cadastrar-link">
        Comprou sem cadastro? <span onClick={this.openGuestLogin}>Acompanhe seu pedido aqui</span>
      </p>
    ) : (
      <p className="cadastrar-link">
        não tem cadastro?{' '}
        <Link to={`/cadastro/comprador${this.props.location.search}`}>Cadastre-se</Link>
      </p>
    );
  };

  showGuestRegisterLink = () => {
    if (isQuiosque()) {
      return (
        <p className="cadastrar-link">
          Ou cadastre-se como{' '}
          <Link to={`/cadastro/visitante${this.props.location.search}`}>visitante</Link>
        </p>
      );
    }
  };

  openGuestLogin = () => {
    this.setState(state => ({
      ...state,
      guestLogin: {
        ...state.guestLogin,
        isShowing: true
      }
    }));
  };
  showRetrievePasswordPopUp = () => {
    const title = 'Trocar a senha';
    const content = (
      <ForgotPasswordForm
        email={this.state.email}
        onSuccess={this.showEmailSentPopUp}
        closePopUp={this.closePopUp}
      />
    );
    this.showPopUp(title, content);
  };
  showEmailSentPopUp = email => {
    const title = 'E-mail enviado';
    const content = (
      <span>
        Caso exista uma conta com o <strong>{email}</strong> que você digitou, vamos enviar um
        e-mail para <strong>{email}</strong> com as instruções e o link para você trocar a senha. Se
        você não receber o e-mail em alguns minutos, verifique a sua caixa de spam ou tente
        novamente.
      </span>
    );
    this.showPopUp(title, content);
  };
  showPopUp = (title, content) => {
    this.setState({ popup: { isShowing: true, title, content } });
  };
  closePopUp = () => {
    this.setState({ popup: { isShowing: false, title: '', content: null } });
  };
  toggleShowPassword = () => {
    this.setState(state => ({
      ...state,
      login: {
        ...state.login,
        showPassword: !state.login.showPassword
      }
    }));
  };

  submitLogin = async event => {
    try {
      event.preventDefault();

      if (this.state.login.isSubmitting) {
        this.proceedLogin();
      }

      this.turnLoadingOn('login');
      const captchaResponse = enableCaptchaOnLogin ? await this.captcha.getResponse() : '';
      this.proceedLogin(captchaResponse);
    } catch (error) {
      this.captcha.reset();
      dispatchErrorEvent(error);
      this.turnLoadingOff('login');
      this.handleError('login', 'email')(error);
      sendFailMessage(error);
    }
  };

  proceedLogin = async captchaResponse => {
    try {
      const { email, password, cnpj } = this.state.login;
      const authenticationInfo = Boolean(cnpj)
        ? { email, password, cnpj, captchaResponse }
        : { email, password, captchaResponse };

      const authentication = await login(authenticationInfo);

      if (isEmbedded()) {
        sendSuccessfulyMessage();
      } else {
        const url = getStepAfterLogin(authentication);
        pushOrRedirect(this.props.history.push, url);
      }
      this.turnLoadingOff('login');
    } catch (error) {
      if (error.errorCode !== '412') {
        this.handleError('login', 'email')(error);
        this.captcha.reset();
      }

      dispatchErrorEvent(error);
      this.turnLoadingOff('login');
      sendFailMessage(error);
    }
  };

  submitGuest = event => {
    event.preventDefault();
    this.turnLoadingOn('guestLogin');

    login({
      orderId: this.state.guestLogin.orderId,
      cpf: this.state.guestLogin.cpf
    })
      .then(getStepAfterLogin)
      .then(pushOrRedirect(this.props.history.push))
      .then(() => this.turnLoadingOff('guestLogin'))
      .catch(this.handleError('guestLogin', 'orderId'));
  };

  handleError = (formName, idToBeFocused) => ({ errorCode }) => {
    setFocusById(idToBeFocused);
    this.turnLoadingOff(formName);
    const defaultErrorMessage = this.state[formName].defaultErrorMessage;

    if (isCustomerLocked(errorCode)) {
      this.showRetrievePasswordPopUp();
    } else {
      this.setState(state => ({
        ...state,
        [formName]: {
          ...state[formName],
          errorMessage: getErrorMessageByErrorCode(errorCode, defaultErrorMessage)
        }
      }));
    }
  };
  turnLoadingOn = formName => {
    this.setState(state => ({
      ...state,
      [formName]: {
        ...state[formName],
        isSubmitting: true,
        errorMessage: ''
      }
    }));
  };
  turnLoadingOff = formName => {
    this.setState(state => ({
      ...state,
      [formName]: {
        ...state[formName],
        isSubmitting: false
      }
    }));
  };
  handleChange = (formName, transformValue = v => v) => ({ target }) => {
    this.setState(state => ({
      ...state,
      [formName]: {
        ...state[formName],
        [target.name]: transformValue(target.value)
      }
    }));
  };
  isGuestLogin = () => {
    const params = getAllQueryParams();
    return hasLoginGuestInParams(params);
  };
}

export default withRouter(Entrar);
